import React from "react";
import styled from "styled-components";

import useViewStore from "../../store/useViewStore";

const Container2 = ({ children, ...props }) => {
  const { isMobileView } = useViewStore();

  return (
    <CContainer $isMobileView={isMobileView} {...props}>
      {children}
    </CContainer>
  );
};

const CContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--aia-bx-white);
  ${(props) => props.$isMobileView ? `padding: 32px 16px;` : `padding: 32px 48px;`}
  margin-bottom: 0px;
  border-radius: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
`;

export default Container2;